import prefix from '../prefix';

export const KEY_CUTTERS_FETCH = prefix('KEY_CUTTERS_FETCH');
export const PRINTERS_FETCH = prefix('PRINTERS_FETCH');
export const PAYMENT_TERMINAL_FETCH = prefix('PAYMENT_TERMINAL_FETCH');
export const PASSPORT_SCANNER_INTEGRATIONS_FETCH = prefix('PASSPORT_SCANNER_INTEGRATIONS_FETCH');
export const PAYMENTS_FETCH = prefix('PAYMENTS_FETCH');

export const COMMAND_CREATE = prefix('COMMAND_CREATE');
